module.exports = __webpack_public_path__ + "img/videoProducT2.fde6b786.png";